<template>

<div class="liveradio top-spacing radio-page">

<loader v-if="loading"></loader>

<div class="radio-container">

<!-- PLAYER -->

<div class="player-section">

<div class="radio-live">

<div class="image-slider">

<img
v-for="(image,index) in songImageArray"
:key="index"
:src="image"
:class="{active:index===currentImageIndex}"
>

</div>

<div class="push-play">

<a v-if="!isPlaying"
class="play"
href="javascript:void();"
@click="playRadio(selectedRadio,liveradio)">

<img src="assets/images/radio-play.png">

</a>

<a v-if="isPlaying"
class="pause"
href="javascript:void();"
@click="pauseRadio()">

<img src="assets/images/radio-pause.png">

</a>

<div class="red-dot"></div>

</div>

<div class="radio-title">

<img :src="radio_img">

</div>

</div>

</div>


<!-- DIVIDER -->

<div class="radio-divider"></div>


<!-- RADIO LIST -->

<h2 class="radio-heading">

Lista de radios

</h2>


<div class="radio-grid">

<div
v-for="radio in liveradio"
:key="radio.radio_id"
class="radio-box"
@click="selectRadio(radio)"
:class="{activeRadio:selectedRadio &&
selectedRadio.radio_id==radio.radio_id}"
>

<img
:src="radio.radio_logo"
class="radio-grid-img">

<p>

{{radio.song_name}}

</p>

</div>

</div>


</div>

</div>

</template>
<script>

import {HTTP} from '../../_helper/http-constants.js';

import { EventEmmiter } from "../../eventEmmiter.js";

export default {

name:"LiveRadio",

data(){

return{

user:JSON.parse(
window.localStorage.getItem('user')
),

liveradio:[],

selectedRadio:null,

loading:false,

songImageArray:[],

currentImageIndex:0,

isPlaying:false,

currentPlaying:null,

device_type:'web',

token:'',

radio_img:''

}

},

methods:{


getLiveRadio(){

this.loading=true;

HTTP.get('/multipleradio')

.then(res=>{

if(res.data.status===200){

this.liveradio=res.data.data;

/* default radio */

if(this.liveradio.length){

this.selectedRadio=
this.liveradio[0];

this.songImageArray=
this.selectedRadio.song_image;

this.radio_img=
this.selectedRadio.radio_logo;

/* autoplay */

this.autoPlayLatestRadio();

}

}

this.loading=false;

})

.catch(()=>{

this.loading=false;

});

},

autoPlayLatestRadio(){

if(!this.liveradio.length) return;

setTimeout(()=>{

try{

this.playRadio(
this.liveradio[0],
this.liveradio
);

}catch(e){

console.log("Autoplay blocked");

}

},800);

},

selectRadio(radio){

this.selectedRadio=radio;

this.songImageArray=
radio.song_image;

this.radio_img=
radio.radio_logo;

this.playRadio(radio,this.liveradio);

},


changeImage(index){

this.currentImageIndex=index;

},


startAutoplay(){

setInterval(()=>{

if(this.songImageArray.length){

this.currentImageIndex=

(this.currentImageIndex+1)

%

this.songImageArray.length;

}

},5000);

},


playRadio(song,AllSong){

/* prevent restart */

if(this.currentPlaying == song.radio_id){
return;
}

this.currentPlaying = song.radio_id;

let songPlayList=[];

songPlayList.push(song);

/* add other radios as playlist */

if(AllSong && AllSong.length){

const remaining = AllSong.filter(r=>{

return r.radio_id != song.radio_id;

});

songPlayList = songPlayList.concat(remaining);

}

const finalPlayList = JSON.parse(

JSON.stringify(

this.preparePlayListArry(songPlayList)

)

);

this.changePlaySong(finalPlayList);

this.isPlaying=true;

},


pauseRadio(){

this.isPlaying=false;

window.parent.onPauseAudio();

},


changePlaySong(songDetailObj){

EventEmmiter.$emit(
"currentSongObject",
songDetailObj
);

},


preparePlayListArry(songListArry){

let songListResArry=[];

songListArry.forEach(songObj=>{

const newSongObj={};

newSongObj.id=
songObj.radio_id;

newSongObj.title=
songObj.song_name;

newSongObj.file=
songObj.song;

newSongObj.poster=
songObj.song_image[0];

newSongObj.description='';

songListResArry.push(newSongObj);

});

return songListResArry;

}


},


mounted(){

this.getLiveRadio();

this.startAutoplay();

/* detect navigation */

if(document.referrer){

this.autoPlayLatestRadio();

}


}

}

</script>


<style>
.radio-page{

display:flex;

justify-content:center;

min-height:90vh;

}


.radio-container{

width:100%;

max-width:700px;

margin:auto;

text-align:center;

padding: 20px 10px;

}


/* PLAYER */

.player-section{

margin-bottom:30px;

}


.radio-live{

background:#151515;

padding:20px;

border-radius:20px;

display:inline-block;

max-width: 500px;
}


/* DIVIDER */

.radio-divider{

height:1px;

background:#2a2a2a;

margin:30px 0 20px;

}


/* TITLE */

.radio-heading{

color:white;

margin-bottom:25px;

font-weight:500;

}


/* GRID */

.radio-grid{

display:grid;

grid-template-columns:

repeat(auto-fit,minmax(140px,1fr));

gap:25px;

justify-content:center;

}


/* BOX */

.radio-box{

background:#151515;

padding:15px;

border-radius:15px;

cursor:pointer;

transition:.3s;

border:1px solid #2a2a2a;

}


.radio-box:hover{

transform:translateY(-5px);

border-color:#00e0ff;

}


.activeRadio{

border:2px solid #00e0ff;

box-shadow:0 0 20px #00e0ff40;

}


/* IMAGE */

.radio-grid-img{

width:90px;

height:90px;

border-radius:12px;

object-fit:cover;

margin-bottom:10px;

}


/* TEXT */

.radio-grid p{

color:white;

font-size:14px;

margin:0;

}


/* PLAYER IMAGE */

.image-slider{

position:relative;

width:407px;

height:407px;

margin:20px auto;

border-radius:20px;

overflow:hidden;

background:#1a1a1a;

display:flex;

align-items:center;

justify-content:center;

border:.6px solid;
width: 219px;
height: 219px;

}


.image-slider img{

max-width:100%;

max-height:100%;

object-fit:contain;

border-radius:20px;

position:absolute;

opacity:0;

transition:opacity 1s;

}


.image-slider img.active{

opacity:1;

}


/* LIVE DOT */

.red-dot{

width:20px;

height:20px;

background:red;

border-radius:50%;

animation:fadeInOut 2s infinite;

position:absolute;

top:24px;

right:-44px;

}


@keyframes fadeInOut{

0%{opacity:0}

50%{opacity:1}

100%{opacity:0}

}
.push-play {
	position: relative;
}


</style>